import React from "react";
import { Select, SelectProps } from "antd";
import { useGetProductTypesQuery } from "../../../api/usim/uploads/products/productTypeApi";

interface ProductTypeDropdownProps extends SelectProps {
  // You can add custom props here if needed
}

export const ProductTypeDropdown: React.FC<ProductTypeDropdownProps> = (props) => {
  const { data: productTypes, isFetching } = useGetProductTypesQuery();

  const options = React.useMemo(() => {
    if (!productTypes) return [];
    // Filter active types
    return productTypes
      .filter((item) => item.status !== false)
      .map((item) => ({
        label: item.name,
        value: item.name,
      }));
  }, [productTypes]);

  return (
    <Select
      placeholder="Select product type"
      showSearch
      filterOption={(input, option) =>
        String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      loading={isFetching}
      options={options}
      {...props}
    />
  );
};
